import { TranslationBuilder } from '~/code/components/Translation'

export default TranslationBuilder.create<{
    errors: {
        [GLOBAL_ERROR_DEFAULT: string]: string
    }
}>()
